import React from 'react'
import { PaginationContainer } from '../styled'
import { ButtonSecondary } from 'components/Button'

interface PaginationProps {
  currentPage: number
  pageCount: number
  handlePageChange: (value: number) => void
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, handlePageChange, pageCount }) => {
  return (
    <PaginationContainer>
      <ButtonSecondary onClick={() => handlePageChange(0)} disabled={currentPage === 0}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-left"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M11 7l-5 5l5 5" />
          <path d="M17 7l-5 5l5 5" />
        </svg>
      </ButtonSecondary>

      <ButtonSecondary onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M15 6l-6 6l6 6" />
        </svg>
      </ButtonSecondary>

      <span>
        Page {currentPage + 1}/{pageCount}{' '}
      </span>

      <ButtonSecondary onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage + 1 >= pageCount}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 6l6 6l-6 6" />
        </svg>
      </ButtonSecondary>
      <ButtonSecondary onClick={() => handlePageChange(pageCount - 1)} disabled={currentPage + 1 >= pageCount}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-right"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M7 7l5 5l-5 5" />
          <path d="M13 7l5 5l-5 5" />
        </svg>
      </ButtonSecondary>
    </PaginationContainer>
  )
}
export default Pagination
